import * as React from "react";
import AppointmentTypeList from "./AppointmentTypeList.js";
/* empty css                         */
import { useAppointmentTypes } from "../../../../../pages/BookAppointment/hooks/v3/pages/BookAppointment/hooks/use-appointment-types.js";
const AppointmentTypeListContainer = (props) => {
  const {
    appointmentTypeIcons,
    appointmentTypeToolTips,
    appointmentGlobalLabels,
    groupedAppointmentTypeToolTips,
    groupedAppointmentGlobalLabels
  } = useAppointmentTypes();
  return /* @__PURE__ */ React.createElement(
    AppointmentTypeList,
    {
      ...props,
      appointmentTypeIcons,
      appointmentTypeToolTips,
      appointmentGlobalLabels,
      groupedAppointmentTypeToolTips,
      groupedAppointmentGlobalLabels
    }
  );
};
export {
  AppointmentTypeListContainer as default
};
//# sourceMappingURL=AppointmentTypeListContainer.js.map
